/**
 * Globale Projekt-Typ Farblogik
 * Wird systemweit verwendet: Projekte, Einsatzplanung, CRM, Zeiterfassung, Stundenkonto
 */

export const PROJECT_TYPE_COLORS = {
  neubau_logistik:     "#3B82F6", // Blau
  sanierung_industrie: "#F97316", // Orange
  sanierung_logistik:  "#EAB308", // Gelb
  office:              "#6B7280", // Grau
  retail_gastro:       "#22C55E", // Gruen
  wohnungsbau:         "#8B5CF6", // Lila
  sonstiges:           "#94A3B8", // Slate/Neutral
};

export const PROJECT_TYPE_LABELS = {
  neubau_logistik:     "Neubau Logistik",
  sanierung_industrie: "Sanierung Industrie",
  sanierung_logistik:  "Sanierung Logistik",
  office:              "Office",
  retail_gastro:       "Retail / Gastro",
  wohnungsbau:         "Wohnungsbau",
  sonstiges:           "Sonstiges",
};

export const PROJECT_STATUS_LABELS = {
  aktiv:       "Aktiv",
  in_planung:  "In Planung",
  kalkulation: "Kalkulation",
  inaktiv:     "Inaktiv",
  archiviert:  "Archiviert",
  sonstiges:   "Sonstiges",
};

export const PROJECT_STATUS_COLORS = {
  aktiv:       "#166534",
  in_planung:  "#92400e",
  kalkulation: "#1d4ed8",
  inaktiv:     "#6b7280",
  archiviert:  "#b45309",
  sonstiges:   "#94A3B8",
};

export const PROJECT_TYPE_OPTIONS = Object.entries(PROJECT_TYPE_LABELS).map(([value, label]) => ({ value, label }));
export const PROJECT_STATUS_OPTIONS = Object.entries(PROJECT_STATUS_LABELS).map(([value, label]) => ({ value, label }));

/**
 * Gibt die Farbe fuer einen Projekttyp zurueck
 */
export function getProjectTypeColor(projectType) {
  return PROJECT_TYPE_COLORS[projectType] || PROJECT_TYPE_COLORS.sonstiges;
}

/**
 * Gibt das Label fuer einen Projekttyp zurueck
 */
export function getProjectTypeLabel(projectType) {
  return PROJECT_TYPE_LABELS[projectType] || projectType || "Sonstiges";
}
